/// <reference path="../icustomstate.ts" />

module Blocks.Interfaces {
    export interface IRouterFactory extends ng.IServiceProvider {
        currentState: App.Interfaces.ICustomState;
        configureRoutes(routes: App.Interfaces.ICustomState[]): void;
        states: App.Interfaces.ICustomState[];
        routeCounts: {
            errors: number;
            changes: number;
        };
        setPipelineRoutes(pipelineSteps: string[]): void;
    }
}